module.exports = __webpack_public_path__ + "img/managegoal.ef1e4ab1.png";